// extracted by mini-css-extract-plugin
export default {"restorePasswordSentPopup":"restore-password-sent-popup_restorePasswordSentPopup__eqBpO"};